'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _reactAvatarEditor = require('react-avatar-editor');

var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _inputValidations = require('../input-validations');

var _inputValidations2 = _interopRequireDefault(_inputValidations);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

var _reactSlider = require('react-slider');

var _reactSlider2 = _interopRequireDefault(_reactSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputImage = function (_React$Component) {
  _inherits(InputImage, _React$Component);

  function InputImage(props) {
    _classCallCheck(this, InputImage);

    var _this = _possibleConstructorReturn(this, (InputImage.__proto__ || Object.getPrototypeOf(InputImage)).call(this, props));

    _this.editor = null;
    _this.getImageProperties = _this.getImageProperties.bind(_this);
    _this.handleClearImage = _this.handleClearImage.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleOrientationChange = _this.handleOrientationChange.bind(_this);
    _this.handleRotateImage = _this.handleRotateImage.bind(_this);
    _this.handleSetImage = _this.handleSetImage.bind(_this);
    _this.setRef = _this.setRef.bind(_this);
    _this.state = {
      height: props.height,
      image: props.value && props.value.indexOf('base64') > -1 ? props.value : null,
      orientation: props.height > props.width ? 'portrait' : 'landscape',
      rotate: 0,
      width: props.width,
      zoom: 100
    };
    return _this;
  }

  _createClass(InputImage, [{
    key: 'handleChange',
    value: function handleChange() {
      var canvas = this.editor.getImageScaledToCanvas();
      var context = canvas.getContext('2d');
      context.globalCompositeOperation = 'destination-over';
      context.fillStyle = 'white';
      context.fillRect(0, 0, canvas.width, canvas.height);

      var image = canvas.toDataURL('image/jpeg', 1);

      this.props.onChange(image);
    }
  }, {
    key: 'handleClearImage',
    value: function handleClearImage(event) {
      var _props = this.props,
          width = _props.width,
          height = _props.height,
          onChange = _props.onChange;


      event.preventDefault();
      this.setState({
        height: height,
        image: null,
        orientation: height > width ? 'portrait' : 'landscape',
        rotate: 0,
        width: width,
        zoom: 100
      });

      onChange(null);
    }
  }, {
    key: 'handleOrientationChange',
    value: function handleOrientationChange(event) {
      var _state = this.state,
          width = _state.width,
          height = _state.height,
          orientation = _state.orientation;


      event.preventDefault();

      if (this.props.orientationChange) {
        this.setState({
          orientation: orientation === 'landscape' ? 'portrait' : 'landscape',
          width: height,
          height: width
        }, this.handleChange);
      }
    }
  }, {
    key: 'handleRotateImage',
    value: function handleRotateImage(event) {
      var _state2 = this.state,
          width = _state2.width,
          height = _state2.height,
          rotate = _state2.rotate;


      event.preventDefault();
      this.setState({ rotate: rotate + 90, width: height, height: width }, this.handleChange);
    }
  }, {
    key: 'getImageProperties',
    value: function getImageProperties(image) {
      var maxSize = this.props.maxSize;

      var orientation = image.height > image.width ? 'portrait' : 'landscape';
      var aspectRatio = image.width / image.height;

      if (orientation === 'portrait') {
        var _height = Math.min(image.height, maxSize);
        var _width = _height * aspectRatio;

        return { width: _width, height: _height, orientation: orientation };
      }

      var width = Math.min(image.width, maxSize);
      var height = width / aspectRatio;

      return { width: width, height: height, orientation: orientation };
    }
  }, {
    key: 'handleSetImage',
    value: function handleSetImage(image) {
      var _this2 = this;

      var _props2 = this.props,
          onFileChange = _props2.onFileChange,
          resizeOnUpload = _props2.resizeOnUpload;

      var reader = new window.FileReader();
      var img = new window.Image();

      if (resizeOnUpload) {
        reader.readAsDataURL(image);
        reader.onload = function (event) {
          img.src = event.target.result;
          img.onload = function () {
            var _getImageProperties = _this2.getImageProperties(img),
                width = _getImageProperties.width,
                height = _getImageProperties.height,
                orientation = _getImageProperties.orientation;

            _this2.setState({ image: image, orientation: orientation, width: width, height: height }, _this2.handleChange);
          };
        };
      } else {
        this.setState({ image: image }, this.handleChange);
      }

      onFileChange && onFileChange(image);
    }
  }, {
    key: 'setRef',
    value: function setRef(el) {
      this.editor = el;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          borderWidth = _props3.borderWidth,
          buttonProps = _props3.buttonProps,
          classNames = _props3.classNames,
          error = _props3.error,
          label = _props3.label,
          note = _props3.note,
          orientationChange = _props3.orientationChange,
          required = _props3.required,
          styles = _props3.styles,
          validations = _props3.validations;
      var _state3 = this.state,
          height = _state3.height,
          image = _state3.image,
          orientation = _state3.orientation,
          rotate = _state3.rotate,
          width = _state3.width,
          zoom = _state3.zoom;


      return _react2.default.createElement(
        'div',
        { className: classNames.root },
        _react2.default.createElement(
          _label2.default,
          { required: required },
          label
        ),
        image ? _react2.default.createElement(
          'div',
          { className: classNames.image },
          _react2.default.createElement(_reactAvatarEditor2.default, {
            border: Math.max(width, height) * borderWidth,
            color: [0, 0, 0, 0.125],
            disableHiDPIScaling: true,
            height: height,
            image: image,
            onImageChange: this.handleChange,
            onImageReady: this.handleChange,
            ref: this.setRef,
            rotate: rotate,
            scale: zoom / 100,
            style: { width: '100%', height: 'auto' },
            width: width
          }),
          orientationChange && _react2.default.createElement(
            _button2.default,
            {
              background: 'light',
              foreground: 'dark',
              spacing: 0.25,
              styles: styles.orientation,
              onClick: this.handleOrientationChange,
              title: 'Change to ' + (orientation === 'portrait' ? 'landscape' : 'portrait') + ' orientation.'
            },
            _react2.default.createElement(_icon2.default, {
              name: orientation === 'portrait' ? 'image' : 'portrait'
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            image.name && _react2.default.createElement(
              'span',
              { className: classNames.fileInfo },
              image.name
            ),
            _react2.default.createElement(
              _button2.default,
              {
                background: 'transparent',
                effect: 'grow',
                spacing: 0.5,
                foreground: 'dark',
                className: classNames.clear,
                onClick: this.handleClearImage
              },
              'Clear Image'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: classNames.controls },
            _react2.default.createElement(_reactSlider2.default, {
              ariaLabel: 'Zoom',
              ariaValuetext: 'Zoom: ' + zoom + '%',
              className: classNames.slider,
              trackClassName: classNames.sliderTrack,
              thumbClassName: classNames.sliderHandle,
              defaultValue: 100,
              min: 0,
              max: 200,
              onChange: function onChange(zoom) {
                return _this3.setState({ zoom: zoom });
              },
              value: zoom,
              renderThumb: function renderThumb(props, state) {
                return _react2.default.createElement(
                  'div',
                  props,
                  _react2.default.createElement(_icon2.default, { styles: styles.icon, name: 'search', size: 0.75 })
                );
              }
            }),
            _react2.default.createElement(
              _button2.default,
              {
                background: 'transparent',
                foreground: 'dark',
                effect: 'grow',
                spacing: 0,
                onClick: this.handleRotateImage
              },
              _react2.default.createElement(_icon2.default, { name: 'rotate', size: 1.5, rotate: rotate })
            )
          )
        ) : _react2.default.createElement(
          'div',
          { className: classNames.dropzoneContainer },
          _react2.default.createElement(
            _reactDropzone2.default,
            {
              accept: 'image/*',
              onDrop: function onDrop(images) {
                return _this3.handleSetImage(images[0]);
              }
            },
            function (_ref) {
              var getRootProps = _ref.getRootProps,
                  getInputProps = _ref.getInputProps;
              return _react2.default.createElement(
                'div',
                _extends({}, getRootProps(), { className: classNames.dropzone }),
                _react2.default.createElement('input', getInputProps()),
                _react2.default.createElement(
                  _button2.default,
                  buttonProps,
                  'Select Image'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Upload an image or drop a file into this area',
                  note && _react2.default.createElement(
                    'small',
                    { className: classNames.note },
                    note
                  )
                )
              );
            }
          )
        ),
        error && _react2.default.createElement(_inputValidations2.default, { validations: validations })
      );
    }
  }]);

  return InputImage;
}(_react2.default.Component);

InputImage.defaultProps = {
  borderWidth: 0.05,
  height: 500,
  maxSize: 1600,
  maxWidth: 350,
  width: 500
};

InputImage.propTypes = {
  /**
   * Border width (as fraction of total width)
   */
  borderWidth: _propTypes2.default.number,

  /**
   * Props to be passed to the Button component
   */
  buttonProps: _propTypes2.default.object,

  /**
   * The label for the field
   */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * The max width/length of an uploaded image
   */
  maxSize: _propTypes2.default.number,

  /**
   * The name of the field
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * The change handler that will receive the updated value as it's only param
   */
  onChange: _propTypes2.default.func.isRequired,

  /**
   * The change handler that will receive the updated file
   */
  onFileChange: _propTypes2.default.func,

  /**
   * Allow user to change orientation of image
   */
  orientationChange: _propTypes2.default.bool,

  /**
   * Resize canvas on image upload to match image dimensions
   */
  resizeOnUpload: _propTypes2.default.bool,

  /**
   * Mark the field as required and displays an asterisk next to the label
   */
  required: _propTypes2.default.bool,

  /**
   * A note to show under the button
   */
  note: _propTypes2.default.string
};

exports.default = (0, _withStyles2.default)(_styles2.default)(InputImage);